import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import Icon from "../components/Icons";
import CtaBand from "../components/CtaBand";
import styles from "./PhysiotherapyPage.module.css";
import { categories, servicesByCategory } from "../data/services";

/** Landing page for the physiotherapy branch — each card is a page. */
export default function PhysiotherapyPage() {
  const items = servicesByCategory("physiotherapy");
  const category = categories.physiotherapy;

  return (
    <>
      <PageHeader
        eyebrow={category.label}
        title={category.title}
        lead={category.lead}
      />

      <section className={`u-section ${styles.section}`}>
        <div className="u-shell">
          <ul className={styles.grid}>
            {items.map((item, i) => (
              <Reveal
                as="li"
                key={item.slug}
                delay={Math.min(i, 5) * 70}
                className={styles.cell}
              >
                <Link
                  to={`/physiotherapy/${item.slug}`}
                  className={styles.card}
                >
                  <span className={styles.icon}>
                    <Icon name={item.icon} size={24} />
                  </span>
                  <h2 className={styles.title}>{item.title}</h2>
                  <p className={styles.text}>{item.short}</p>
                  <span className={styles.more}>
                    Learn more
                    <Icon name="arrow" size={16} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
